import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
// react redux
import { useSelector } from "react-redux";
// react-hook-form
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
// mui
import { Stack, FormControlLabel, Switch } from "@mui/material";
// componennts
import {
    PageTitle,
    SubmitButton,
    InputField,
    ThreeDotsLoader,
} from "../../components";
// schema
import { editOperatorSchema } from "../../schemes/operator/editOperatorSchema";
import { errorAlert, successAlert } from "../../utils/alerts/alerts";
// form values type
type FormValues = {
    name: string;
    email: string;
    password: string;
    password_confirmation: string;
    is_disabled: boolean;
};

const EditOperator = () => {
    const navigate = useNavigate();
    const { operatorId } = useParams();
    const userToken = useSelector((state: any) => state.user.userToken);
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(true);
    // --------------------------- form handle ---------------------------
    const form = useForm<FormValues>({
        defaultValues: {
            name: "",
            email: "",
            password: "",
            password_confirmation: "",
            is_disabled: false,
        },
        resolver: yupResolver(editOperatorSchema),
        mode: "all",
    });
    const {
        register,
        setValue,
        getValues,
        reset,
        control,
        watch,
        formState: { errors },
        handleSubmit,
    } = form;
    // submit form
    const onSubmit: SubmitHandler<FormValues> = (data: any) => {
        if (data.password === "") {
            delete data.password;
            delete data.password_confirmation;
        }
        setSubmitting(true);
        EnhancedAxios(null, userToken)
            .put(`/admin/users/${operatorId}`, data)
            .then((res: any) => {
                successAlert(`تم تعديل المشغل  '${data.name}'`);
                setSubmitting(false);
                navigate(-1);
            })
            .catch((error: any) => {
                errorAlert(error);
                setSubmitting(false);
            });
    };
    // get operator data
    useEffect(() => {
        EnhancedAxios(null, userToken)
            .get(`/admin/users/${operatorId}`)
            .then((res: any) => {
                reset({
                    name: res.data.name,
                    email: res.data.email,
                    is_disabled: res.data.is_disabled,
                });
                setLoading(false);
            })
            .catch((error: any) => {
                errorAlert(error);
            });
    }, []);
    // while page is loading
    if (loading) return <ThreeDotsLoader />;
    return (
        <Stack gap="20px">
            <PageTitle title="تعديل مشغل" />
            <Stack alignItems="center">
                <Stack
                    width="100%"
                    maxWidth="800px"
                    gap="10px"
                    component="form"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <InputField
                        type="text"
                        registration={{ ...register("name") }}
                        label="الاسم"
                        errorMessage={errors?.name?.message}
                    />
                    <InputField
                        type="email"
                        registration={{ ...register("email") }}
                        label="البريد الالكتروني"
                        errorMessage={errors?.email?.message}
                    />
                    <InputField
                        type="password"
                        registration={{ ...register("password") }}
                        label="الرقم السري"
                        errorMessage={errors?.password?.message}
                    />
                    <InputField
                        type="password"
                        registration={{ ...register("password_confirmation") }}
                        label="تآكيد الرقم السري "
                        errorMessage={errors?.password_confirmation?.message}
                    />
                    <Controller
                        name="is_disabled"
                        control={control}
                        render={({ field }) => (
                            <FormControlLabel
                                control={
                                    <Switch
                                        {...field}
                                        checked={!watch("is_disabled")}
                                        onChange={(e) =>
                                            setValue(
                                                "is_disabled",
                                                !e.target.checked
                                            )
                                        }
                                    />
                                }
                                label="مفعل"
                            />
                        )}
                    />
                    <SubmitButton label="تعديل" disabled={submitting} />
                </Stack>
            </Stack>
        </Stack>
    );
};

export default EditOperator;
